var g1 = "/static/efbe676587eae8a9.png";

export { g1 as default };
//# sourceMappingURL=g_1.png.js.map
